<template>
  <div class="error-view">
    <img :src="page.image" class="image" :alt="`${page.title}图片`">
    <div class="content">
      <span class="title">{{ page.title }}</span>
      <span class="desc">{{ page.desc }}</span>
      <el-button type="primary" @click="$router.back()" v-if="showBack">
        返回
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'  
import image403 from './assets/403.svg'
import image404 from './assets/404.svg'
import image500 from './assets/500.svg'

type Props = {
  status: string
  showBack: boolean
};

const props = withDefaults(defineProps<Props>(), {
  status: '404',
  showBack: true
})

type Data = {
  [key: string]: {
    title: string
    desc: string
    image: string
  }
}
const data:Data = {
  403: {
    title: '403',
    desc: '抱歉，你无权访问该页面',
    image: image403
  },
  404: {
    title: '404',
    desc: '抱歉，你访问的页面不存在',
    image: image404
  },
  500: {
    title: '500',
    desc: '抱歉，服务器出错了',
    image: image500
  }
}

const page = computed(() => {
  return data[props.status]
})


defineOptions({
  name: 'TqErrorView'
})

</script>

<style lang="stylus">
.error-view {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	margin-left: 10px;
}

.error-view .image {
	display: block;
	width: 430px;
	height: 360px;
}

.error-view .content {
	margin-left: 120px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.error-view .content .title {
	color: #434e59;
	font-size: 72px;
	font-weight: 600;
	line-height: 72px;
	margin-bottom: 24px;
}

.error-view .content .desc {
	color: rgba(0,0,0,0.45);
	font-size: 20px;
	line-height: 28px;
	margin-bottom: 16px;
}
</style>
